import {
  IS_FETCHING_ACTIVITY_MASTER_DATA,
  ACTIVITY_MASTER_DATA,
  ACTIVITY_MASTER_ERROR_MESSAGE,
} from '../actions/constants';

import {
  fetchManualTrackingMasterData,
} from '../api/shipmentTracking';

export const fetchManualTrackingMaster = params => async (dispatch) => {
  dispatch({
    type: IS_FETCHING_ACTIVITY_MASTER_DATA,
  });
  const response: any = await fetchManualTrackingMasterData(params);
  if (response.isSuccess) {
    dispatch({
      type: ACTIVITY_MASTER_DATA,
      data: response.data,
    });
  } else {
    dispatch({
      type: ACTIVITY_MASTER_ERROR_MESSAGE,
      errorMessage: response.errorMessage,
    });
  }
};
